/**
 * Whitelist of Vuex slices persisted to sessionStorage.
 *
 * The account profile is persisted so features that round-trip between legacy and
 * SC-Web pages (e.g. sitter onboarding, non-childcare search) have account data
 * available immediately on return. Authorization state (premium/basic) is NOT trusted
 * from this snapshot: the `getAccount` getter overlays roles from the live JWT, which
 * the server reissues on upgrade/downgrade, so those flows are never stale.
 */
export function persistedStateReducer(state: any) {
  const persistedChannelUrl = state.messages?.currentChannelUrl || null;

  return {
    account: {
      accountData: state.account?.accountData ?? null,
    },
    messages: {
      currentChannelUrl: persistedChannelUrl,
      channels: state.messages?.channels || [],
      rawChannels: state.messages?.rawChannels || [],
      messages: state.messages?.messages || [],
      selectedOtherUser: state.messages?.selectedOtherUser || null,
      selectedChannelMembers: state.messages?.selectedChannelMembers || [],

      isConnected: false,
      isConnecting: false,
      lastReceivedMessageId: null,
      lastReceivedChannelUrl: null,
      connectionError: null,

      loadingChannels: false,
      channelListError: '',
      loadingMessages: !!persistedChannelUrl,
      messageLoadError: '',
      sendError: '',
      sending: false,
      queryParamChannelNotFound: false,
    },
    sitterOnboarding: state.sitterOnboarding,
  };
}
